export enum REVIEWS_SLIDER_REVIEWS_SEQUENCE {
    DEFAULT = "default",
    SHUFFLE = "shuffle",
}
